import * as Sentry from "@sentry/react";
import { createRoot } from "react-dom/client";
import App from "./App";
import Env from "./utils/env";
import "@patternfly/pfe-markdown/dist/pfe-markdown";
import "@patternfly/pfe-health-index/dist/pfe-health-index";

if (Env.getEnvName() === Env.EnvNames.PROD) {
	Sentry.init({
		dsn: "https://c09c4312e2b042e5974a7c2a30a38d88@o59191.ingest.sentry.io/5775443",
		environment: "production",
		...(import.meta.env.VITE_SPA_VERSION && {
			release: `rhc-product-listing@${import.meta.env.VITE_SPA_VERSION}`,
		}),
		tracesSampleRate: 0.5,
	});
}

const container = document.getElementById("root");
const root = createRoot(container!);
root.render(<App />);
